export const NavItems = [
    { label: "Inicio", href: "#home" },
    { label: "Quienes Somos", href: "#nosotros" },
    { label: "Equipo", href: "#equipo" },
    { label: "Servicios", href: "#servicios" },
    { label: "Contacto", href: "#footer" },
]


export const FooterItems = [
    { label: "Inicio", href: "#home" },
    { label: "Quienes Somos", href: "#nosotros" },
    { label: "Equipo", href: "#equipo" },
    { label: "Servicios", href: "#servicios" },
    { label: "Contacto", href: "#contacto" },
]


export const ServiciosLegales = [
    {
        img: "/familia.png",
        title: "Derecho de Familia",
        description: "Resolvemos tus conflictos y protegemos tus vínculos: Divorcios, Convenio de Alimentos y Régimen comunicacional, Uniones Convivenciales, División de Bienes."
    },
    {
        img:"/sucesiones.jpg",
        title: "Sucesiones",
        description: "Acompañamiento profesional en procesos hereditarios: Trámite Sucesorio Ab Intestato y Testamentario, Tracto Abreviado, Cesión de Derechos y Acciones, Planificación Familiar. Declaratoria de herederos."
    },
    {
        img:"/violencia.png",
        title: "Violencia",
        description: "Solicitud de medidas de protección familiar. Levantamiento de perimetrales. Revinculacion familiar. Violencia de género."
    },
    {
        img:"/derecho_civil.jpg",
        title: "Derecho Civil",
        description: "Prescripciones, desalojos y cobros ejecutivos."
    }
]

export const OtrosServicios = [
    {
        img:"/registrales.png",
        title: "Trámites Registrales",
        description:"Ante el Registro de la Propiedad Inmueble y Registro del Automotor"
    },
    {
        img:"/escribania.jpg",
        title: "Escribania",
        description:"Trámites Notariales, Estudio de Títulos,  Certificaciones."
    }
]

